module.exports = __webpack_public_path__ + "static/Vogue-541e585bab7b5e3d1f06d186d4aa30c5.png";